import React, { Component } from "react";

class SendMessageScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      check: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    console.log(event);
    console.log(event.target.id);
    console.log(this.state)

    if(event.target.id === "requestconfirmation"){
      console.log("Ja hallokes updating the state");
      this.setState(({ check }) => ({ check: !this.state.check }));

    }
    else {
      this.setState({ value: event.target.value });
      console.log(
        "Current message: " +
          this.state.value +
          " current user " +
          this.props.user
      );
    }
    
  }

  handleSubmit(event) {
    console.log("Push Update to Server");
    console.log("Message: " + this.state.value);

    fetch("/send-message", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ message: this.state.value, user: this.props.user, check: this.state.check })
    });
  }

  render() {
    return (
      <div>
        <h3>Send Message to all pilots with EBSH Tower APP </h3>
        <form onSubmit={this.handleSubmit} onChange={this.handleChange}>
          <div className="form-group">
            <textarea
              className="form-control"
              id="exampleFormControlTextarea1"
              rows="3"
            />
            <button type="submit" className="btn btn-primary mb-2">
              Send Message
            </button>
            <div><input
            className="form-check-input"
            type="checkbox"
            checked={this.props.status}
            id="requestconfirmation"
            key="requestconfirmation"
            //onChange={() => console.log("Message Confirmation requested")}
            onChange={event => this.handleChange(event)}
          /> Request Confirmation</div>
          </div>
        </form>
      </div>
    );
  }
}

export default SendMessageScreen;
